import { Profile } from "aint-types";
import { ADMIN_GROUP_NAME } from "aint-utils";

export const isUserAdmin = (profile?: Profile): boolean => {
  if (!profile) {
    return false;
  }
  return profile?.role === ADMIN_GROUP_NAME;
};
